import React, { useState } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react18-swipeable-views";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Fab from "@mui/material/Fab";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import ArrowBack from "@mui/icons-material/ArrowBack";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Switch from "@mui/material/Switch";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import ButtonBase from "@mui/material/ButtonBase";
import Palette from "@mui/icons-material/Palette";
import Close from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import {
  LeftSidebarThumb,
  LeftSidebarBigThumb,
  TopNavigationThumb,
  MegaMenuThumb,
} from "./templatePreview";
import ThemeThumb from "./ThemeThumbs";
import LayoutThumb from "./LayoutThumb";
import useStyles from "./settings-jss";

function TabContainer({ children }) {
  return (
    <Typography component="div" style={{ padding: 8 * 1.5 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

function AppFlagSetting(props) {
  const [show, setShow] = useState(false);

  const { classes, cx } = useStyles();
  const {
    palette,
    mode,
    gradient,
    decoration,
    bgPosition,
    selectedValue,
    layout,
    direction,
    changeTheme,
    changeRandomTheme,
  } = props;

  return (
    <aside
      className={cx(
        classes.settingSidebar,
        layout === "right-sidebar" ? classes.leftSidebar : classes.rightSidebar,
        show && classes.expanded
      )}
    >
      <div className={`${classes.toggleRaiseButton} d-none `}></div>
    </aside>
  );
}

AppFlagSetting.propTypes = {
  palette: PropTypes.array,
  mode: PropTypes.string.isRequired,
  gradient: PropTypes.bool.isRequired,
  decoration: PropTypes.bool.isRequired,
  bgPosition: PropTypes.string.isRequired,
  selectedValue: PropTypes.string.isRequired,
  layout: PropTypes.string.isRequired,
  direction: PropTypes.string.isRequired,
  changeTheme: PropTypes.func.isRequired,
  changeRandomTheme: PropTypes.func.isRequired,
  changeMode: PropTypes.func.isRequired,
  changeGradient: PropTypes.func.isRequired,
  changeDecoration: PropTypes.func.isRequired,
  changeBgPosition: PropTypes.func.isRequired,
  changeLayout: PropTypes.func.isRequired,
  changeDirection: PropTypes.func.isRequired,
};

AppFlagSetting.defaultProps = {
  palette: [],
};

export default AppFlagSetting;
